import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface INumericFormatCustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, INumericFormatCustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, ...rest } = props;

    return (
      <NumericFormat
        {...rest}
        getInputRef={ref}
        decimalScale={2}
        decimalSeparator=","
        fixedDecimalScale
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator="."
        valueIsNumericString
        allowNegative={false}
      />
    );
  },
);

export default NumericFormatCustom;
